import { Button } from "antd";
import styled from "styled-components";

export const ShaButtonStyledWrapper = styled(Button)`
  border: none;
  border-radius: 5px;
  box-shadow: 0px 3px 4px 0px #c1c1c1;
  font-size: 18px;
  height: 50px !important;
`;
